import { createContext, useContext, type ReactNode } from "react";
import type { StoreDeps } from "@repo/share-log-stores";

/** 공유 컴포넌트가 직접 쓰는 의존성. store factory에 넣는 것과 같은 api/logger다 */
export type Deps = StoreDeps;

const DepsContext = createContext<Deps | null>(null);

interface DepsProviderProps {
  deps: Deps;
  children: ReactNode;
}

export function DepsProvider({ deps, children }: DepsProviderProps) {
  return <DepsContext.Provider value={deps}>{children}</DepsContext.Provider>;
}

export function useDeps(): Deps {
  const deps = useContext(DepsContext);
  if (!deps) {
    throw new Error("useDeps는 DepsProvider 안에서만 사용할 수 있습니다.");
  }
  return deps;
}
